import { render, staticRenderFns } from "./MedicalInsuranceLevelDelete.vue?vue&type=template&id=e1482e72&scoped=true&"
import script from "./MedicalInsuranceLevelDelete.vue?vue&type=script&lang=js&"
export * from "./MedicalInsuranceLevelDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1482e72",
  null
  
)

export default component.exports